import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { tokens } from '../../theme/tokens';

const GradientCircularProgress: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        backgroundColor: tokens.colors.offWhite,
        width: '100%',
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="gradient-progress" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#1BA973" stopOpacity="0.6" />
              <stop offset="33%" stopColor="#0897AB" stopOpacity="0.8" />
              <stop offset="66%" stopColor="#5C50F3" stopOpacity="0.95" />
              <stop offset="100%" stopColor="#432568" stopOpacity="1" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress
          size={40}
          thickness={3}
          sx={{
            '& .MuiCircularProgress-circle': {
              stroke: 'url(#gradient-progress)',
              strokeLinecap: 'round',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default GradientCircularProgress;